// extracted by mini-css-extract-plugin
module.exports = {"carouselStyles":"BookingDetails_carouselStyles__4BeaA"};